import { useState } from 'react';
import {
  useAssignableUsers,
  useCreateAssignment,
  useDeleteAssignment,
  useJobAssignments,
} from '../api/assignments';

export default function ReviewersManager({ jobId }: { jobId: string }) {
  const { data: assignments } = useJobAssignments(jobId);
  const { data: users } = useAssignableUsers();
  const create = useCreateAssignment(jobId);
  const remove = useDeleteAssignment(jobId);

  const [userId, setUserId] = useState('');
  const [error, setError] = useState<string | null>(null);

  const reviewers = assignments?.reviewers ?? [];
  const assignedIds = new Set(reviewers.map((r) => r.user.id));
  const options = (users ?? []).filter((u) => !assignedIds.has(u.id));
  const busy = create.isPending || remove.isPending;

  const add = () => {
    if (!userId) return;
    setError(null);
    create.mutate(
      { type: 'REVIEWER', userId },
      {
        onError: (e) => setError(e instanceof Error ? e.message : 'Failed'),
        onSuccess: () => setUserId(''),
      },
    );
  };

  return (
    <div className="assign-block">
      {error && <div className="banner-error">{error}</div>}

      <div className="chips">
        {reviewers.length === 0 && <span className="muted">No reviewers assigned.</span>}
        {reviewers.map((r) => (
          <span key={r.assignmentId} className="chip chip-removable">
            {r.user.displayName}
            <button
              className="chip-x"
              disabled={busy}
              onClick={() => remove.mutate(r.assignmentId)}
              aria-label={`Remove ${r.user.displayName}`}
            >
              ×
            </button>
          </span>
        ))}
      </div>

      <div className="assign-add">
        <select value={userId} onChange={(e) => setUserId(e.target.value)} disabled={busy}>
          <option value="">Add a reviewer…</option>
          {options.map((u) => (
            <option key={u.id} value={u.id}>
              {u.displayName} ({u.email})
            </option>
          ))}
        </select>
        <button className="btn-ghost" onClick={add} disabled={busy || !userId}>
          Add
        </button>
      </div>
    </div>
  );
}
